import { RvrTooltipData } from '../../../services/map-interaction-service';

export function RvrTooltip(props: { info: RvrTooltipData }) {
    const items = props.info.items;

    return (
        <div
            style={{
                minWidth: 140,
                backgroundColor: 'var(--bg-color)'
            }}>
            {items.map((x, i) => (
                <div key={i} className="d-flex align-items-center gap-2 px-2 py-1" style={{ fontSize: 12 }}>
                    <span
                        style={{
                            display: 'inline-block',
                            width: 10,
                            height: 10,
                            backgroundColor: x.color,
                            border: '1px solid #000'
                        }}
                    />
                    <span>{x.label}</span>
                </div>
            ))}
        </div>
    );
}
